var m2 = "/static/0a8cccc30bbb8eab.png";

export { m2 as default };
//# sourceMappingURL=m_2.png.js.map
